// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "frontend-assets/js/" + chunkId + "." + {"60":"0e28f076","91":"7bbabf41","120":"f998786b","180":"60ab1ff3","335":"d098b98d","336":"71c1e52a","394":"d9139028","576":"3916e701","692":"1b54be7f","722":"b9338617","725":"05e5f9ea","760":"628060bf","871":"58bad151","922":"e15425f5"}[chunkId] + ".js";
};